export const cardProps = {
  title: {
    type: String,
    default: 'card-header',
  },
  border: {
    type: Boolean,
    default: true,
  },
  hover: {
    type: Boolean,
    default: false,
  },
  separate: {
    type: Boolean,
    default: false,
  },
  width: {
    type: Number,
    default: 300,
  },
  background: {
    type: String,
    default: '',
  },
}
